// Mock data for UAICARD BUSINESS
// NOTE: This is MOCK data used for the frontend-only MVP.
// It is persisted to localStorage so edits survive reloads.

export const uid = () =>
  `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;

// Brand palette derived from the UAICARD logo (blue gradient + deep navy)
export const BRAND = {
  blue: "#2E6BFF",
  blueDark: "#1B3FB8",
  indigo: "#3B4FE0",
  navy: "#0A1633",
  navySoft: "#0E1E44",
};

const IMG = {
  avatar:
    "https://images.unsplash.com/photo-1509042239860-f550ce710b93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxjb2ZmZWUlMjBzaG9wfGVufDB8fHx8MTc4NzcxODE4N3ww&ixlib=rb-4.1.0&q=85",
  storefront:
    "https://images.pexels.com/photos/19596282/pexels-photo-19596282.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  p1: "https://images.unsplash.com/photo-1529892485617-25f63cd7b1e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxsYXR0ZSUyMGFydHxlbnwwfHx8fDE3ODc3MTgxODd8MA&ixlib=rb-4.1.0&q=85",
  p2: "https://images.unsplash.com/photo-1541167760496-1628856ab772?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxsYXR0ZSUyMGFydHxlbnwwfHx8fDE3ODc3MTgxODd8MA&ixlib=rb-4.1.0&q=85",
  p3: "https://images.unsplash.com/photo-1593443320739-77f74939d0da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxsYXR0ZSUyMGFydHxlbnwwfHx8fDE3ODc3MTgxODd8MA&ixlib=rb-4.1.0&q=85",
  p4: "https://images.unsplash.com/photo-1497636577773-f1231844b336?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxsYXR0ZSUyMGFydHxlbnwwfHx8fDE3ODc3MTgxODd8MA&ixlib=rb-4.1.0&q=85",
  g1: "https://images.unsplash.com/photo-1549166114-bf535a63c671?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxjYWYlQzMlQTklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODc3MTgxODd8MA&ixlib=rb-4.1.0&q=85",
  g2: "https://images.unsplash.com/photo-1648462908676-8305f0eff8e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxjYWYlQzMlQTklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODc3MTgxODd8MA&ixlib=rb-4.1.0&q=85",
  g3: "https://images.unsplash.com/photo-1594873657136-ccd8c9f43866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxjYWYlQzMlQTklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODc3MTgxODd8MA&ixlib=rb-4.1.0&q=85",
  g4: "https://images.pexels.com/photos/5373256/pexels-photo-5373256.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// A full-featured demo portfolio (fictional business: Café Aurora)
export const buildDemoPortfolio = () => ({
  id: "cafe-aurora",
  name: "Café Aurora",
  slug: "cafe-aurora",
  status: "active",
  startDate: "2025-01-15",
  theme: { primary: BRAND.blue, secondary: BRAND.indigo, background: "aurora" },
  profile: {
    avatar: IMG.avatar,
    businessName: "Café Aurora",
    subtitle: "Café de especialidad · Repostería artesanal · Roma Norte, CDMX",
    verified: true,
  },
  blocks: [
    { id: uid(), type: "heading", text: "¡CONTÁCTANOS!" },
    {
      id: uid(),
      type: "button",
      variant: "whatsapp",
      label: "PEDIDOS Y RESERVAS",
      value: "5215576678727",
      message: "Hola, buen día. Me gustaría hacer un pedido en Café Aurora.",
    },
    {
      id: uid(),
      type: "button",
      variant: "email",
      label: "CORREO DE ATENCIÓN",
      value: "hola@cafeaurora.mx",
    },
    { id: uid(), type: "text", text: "Abierto todos los días · 7:00 a 21:00 hrs" },
    {
      id: uid(),
      type: "socials",
      items: [
        { id: uid(), platform: "instagram", url: "https://instagram.com" },
        { id: uid(), platform: "facebook", url: "https://facebook.com" },
        { id: uid(), platform: "tiktok", url: "https://tiktok.com" },
        { id: uid(), platform: "whatsapp", url: "https://wa.me/5215576678727" },
      ],
    },
    { id: uid(), type: "heading", text: "UBICACIÓN" },
    {
      id: uid(),
      type: "location",
      image: IMG.storefront,
      label: "VISÍTANOS / INICIAR NAVEGACIÓN",
      mapUrl: "https://maps.google.com",
    },
    {
      id: uid(),
      type: "text",
      text: "Ven a disfrutar de nuestro tostado de origen y ambiente acogedor en el corazón de la ciudad.",
    },
    {
      id: uid(),
      type: "products",
      title: "NUESTRO MENÚ",
      subtitle: "Descubre nuestras bebidas de autor",
      items: [
        { id: uid(), image: IMG.p1, title: "Latte de la Casa", link: "https://cafeaurora.mx" },
        { id: uid(), image: IMG.p2, title: "Cappuccino Aurora", link: "https://cafeaurora.mx" },
        { id: uid(), image: IMG.p3, title: "Cold Brew Especial", link: "https://cafeaurora.mx" },
        { id: uid(), image: IMG.p4, title: "Espresso de Origen", link: "https://cafeaurora.mx" },
      ],
    },
    {
      id: uid(),
      type: "gallery",
      title: "NUESTRO ESPACIO",
      items: [
        { id: uid(), image: IMG.g1, caption: "AMBIENTE" },
        { id: uid(), image: IMG.g2, caption: "BARRA" },
        { id: uid(), image: IMG.g3, caption: "TERRAZA" },
        { id: uid(), image: IMG.g4, caption: "REPOSTERÍA" },
      ],
    },
    { id: uid(), type: "heading", text: "CONÓCENOS" },
    {
      id: uid(),
      type: "mosaic",
      title: "GALERÍA MOSAICO",
      items: [
        { id: uid(), image: IMG.p1 },
        { id: uid(), image: IMG.g1 },
        { id: uid(), image: IMG.p2 },
        { id: uid(), image: IMG.g2 },
        { id: uid(), image: IMG.p3 },
        { id: uid(), image: IMG.g3 },
        { id: uid(), image: IMG.p4 },
        { id: uid(), image: IMG.g4 },
      ],
    },
    {
      id: uid(),
      type: "youtube",
      title: "La experiencia Café Aurora",
      url: "https://www.youtube.com/watch?v=jfKfPfyJRdk",
    },
    {
      id: uid(),
      type: "button",
      variant: "link",
      label: "VER MENÚ COMPLETO",
      value: "https://cafeaurora.mx",
    },
  ],
});

// Extra portfolios so the dashboard feels populated
export const buildSeedPortfolios = () => [
  buildDemoPortfolio(),
  {
    id: "estudio-lumen",
    name: "Estudio Lumen",
    slug: "estudio-lumen",
    status: "active",
    startDate: "2025-03-02",
    theme: { primary: BRAND.blue, secondary: BRAND.indigo, background: "aurora" },
    profile: {
      avatar: IMG.g3,
      businessName: "Estudio Lumen",
      subtitle: "Fotografía profesional · Bodas y eventos",
      verified: false,
    },
    blocks: [
      { id: uid(), type: "heading", text: "¡AGENDA TU SESIÓN!" },
      {
        id: uid(),
        type: "button",
        variant: "whatsapp",
        label: "COTIZAR AHORA",
        value: "5215500000000",
        message: "Hola, quiero cotizar una sesión de fotos.",
      },
    ],
  },
  {
    id: "boutique-mare",
    name: "Boutique Maré",
    slug: "boutique-mare",
    status: "suspended",
    startDate: "2024-11-20",
    theme: { primary: BRAND.blue, secondary: BRAND.indigo, background: "aurora" },
    profile: {
      avatar: IMG.g4,
      businessName: "Boutique Maré",
      subtitle: "Moda y accesorios · Envíos a todo el país",
      verified: false,
    },
    blocks: [
      { id: uid(), type: "heading", text: "NUEVA COLECCIÓN" },
      {
        id: uid(),
        type: "button",
        variant: "link",
        label: "VER TIENDA",
        value: "https://example.com",
      },
    ],
  },
];

export const BLOCK_CATEGORIES = [
  "Básicos",
  "Contacto y ubicación",
  "Ventas y promociones",
  "Multimedia y galerías",
  "Confianza",
];

export const BLOCK_LIBRARY = [
  { type: "heading", label: "Título de sección", icon: "Heading", category: "Básicos" },
  { type: "text", label: "Texto / párrafo", icon: "Type", category: "Básicos" },
  { type: "button", label: "Botón (WhatsApp / correo / enlace)", icon: "MousePointerClick", category: "Básicos" },
  { type: "socials", label: "Redes sociales", icon: "Share2", category: "Básicos" },
  { type: "divider", label: "Divisor (línea decorativa animada)", icon: "Minus", category: "Básicos" },

  { type: "vcard", label: "Guardar contacto (vCard)", icon: "UserPlus", category: "Contacto y ubicación" },
  { type: "location", label: "Ubicación y navegación", icon: "MapPin", category: "Contacto y ubicación" },
  { type: "qr", label: "Código QR (descargable)", icon: "QrCode", category: "Contacto y ubicación" },

  { type: "products", label: "Carrusel de productos/servicios", icon: "LayoutGrid", category: "Ventas y promociones" },
  { type: "showcase", label: "Vitrina productos/servicios (imagen o video + agendar)", icon: "LayoutGrid", category: "Ventas y promociones" },
  { type: "showcase_strip", label: "Vitrina deslizable (3 en fila, sin flechas)", icon: "LayoutGrid", category: "Ventas y promociones" },
  { type: "menu", label: "Menú / Lista de precios", icon: "ListChecks", category: "Ventas y promociones" },
  { type: "pay", label: "Pagos con tarjeta (Stripe)", icon: "CreditCard", category: "Ventas y promociones" },
  { type: "countdown", label: "Oferta con cuenta regresiva", icon: "Timer", category: "Ventas y promociones" },

  { type: "gallery", label: "Galería de imágenes", icon: "Images", category: "Multimedia y galerías" },
  { type: "image", label: "Insertar imagen (con recorte)", icon: "Image", category: "Multimedia y galerías" },
  { type: "mosaic", label: "Galería mosaico (hasta 12 fotos)", icon: "LayoutPanelTop", category: "Multimedia y galerías" },
  { type: "mosaic_h", label: "Mosaico horizontal (hasta 10 fotos)", icon: "GalleryHorizontalEnd", category: "Multimedia y galerías" },
  { type: "flyers", label: "Flayers 360 (carrusel 3D, hasta 8)", icon: "GalleryHorizontal", category: "Multimedia y galerías" },
  { type: "stories", label: "Historias tipo Instagram", icon: "Circle", category: "Multimedia y galerías" },
  { type: "youtube", label: "Video (YouTube, TikTok, MP4...)", icon: "Youtube", category: "Multimedia y galerías" },
  { type: "audio", label: "Reproductor de audio / Música de fondo", icon: "Music", category: "Multimedia y galerías" },

  { type: "reviews", label: "Reseñas y testimonios", icon: "Star", category: "Confianza" },
  { type: "timeline", label: "Línea de tiempo / Trayectoria", icon: "GitCommitVertical", category: "Confianza" },
];

export const newBlock = (type) => {
  const base = { id: uid(), type };
  switch (type) {
    case "heading":
      return { ...base, text: "NUEVO TÍTULO" };
    case "text":
      return { ...base, text: "Escribe aquí tu texto..." };
    case "button":
      return { ...base, variant: "whatsapp", label: "NUEVO BOTÓN", value: "5210000000000", message: "Hola", icon: "", bgColor: "", opacity: 100, anim: "none", shape: "rounded", borderColor: "" };
    case "divider":
      return { ...base, style: "gradient", color: "#2E6BFF" };
    case "socials":
      return { ...base, items: [{ id: uid(), platform: "instagram", url: "https://instagram.com" }] };
    case "location":
      return { ...base, image: IMG.storefront, label: "VISÍTANOS", mapUrl: "https://maps.google.com" };
    case "products":
      return {
        ...base,
        title: "NUEVOS PRODUCTOS",
        subtitle: "Descripción breve",
        items: [{ id: uid(), image: IMG.p1, title: "Producto 1", link: "https://example.com" }],
      };
    case "showcase":
      return {
        ...base,
        title: "PRODUCTOS Y SERVICIOS",
        subtitle: "",
        items: [
          {
            id: uid(),
            mediaType: "image",
            image: IMG.p1,
            video: "",
            title: "Producto 1",
            description: "Describe aquí tu producto o servicio.",
            btnVariant: "whatsapp",
            btnLabel: "Agendar",
            btnValue: "5210000000000",
            btnMessage: "Hola, quiero agendar / cotizar este producto.",
          },
        ],
      };
    case "showcase_strip":
      return {
        ...base,
        title: "PRODUCTOS Y SERVICIOS",
        subtitle: "",
        stripMotion: "loop",
        items: [1, 2, 3].map((n, i) => ({
          id: uid(),
          mediaType: "image",
          image: [IMG.p1, IMG.p2, IMG.p3][i],
          video: "",
          title: `Producto ${n}`,
          description: "Describe aquí tu producto o servicio.",
          btnVariant: "whatsapp",
          btnLabel: "Agendar",
          btnValue: "5210000000000",
          btnMessage: "Hola, quiero agendar / cotizar este producto.",
        })),
      };
    case "gallery":
      return { ...base, title: "GALERÍA", items: [{ id: uid(), image: IMG.g1, caption: "Foto" }] };
    case "flyers":
      return { ...base, title: "FLAYERS 360", items: [] };
    case "pay":
      return { ...base, title: "Paga en línea", description: "Paga de forma segura con tu tarjeta.", price: "", payLink: "", btnLabel: "Pagar con tarjeta" };
    case "mosaic_h":
      return { ...base, title: "MOSAICO HORIZONTAL", items: [] };
    case "mosaic":
      return {
        ...base,
        title: "GALERÍA MOSAICO",
        items: [
          { id: uid(), image: IMG.g1 },
          { id: uid(), image: IMG.p1 },
          { id: uid(), image: IMG.g2 },
          { id: uid(), image: IMG.p2 },
          { id: uid(), image: IMG.g3 },
          { id: uid(), image: IMG.p3 },
        ],
      };
    case "youtube":
      return { ...base, title: "Nuevo video", url: "https://www.youtube.com/watch?v=jfKfPfyJRdk", uploadUrl: "" };
    case "vcard":
      return {
        ...base,
        label: "Guardar contacto",
        name: "Mi Negocio",
        org: "",
        title: "",
        phone: "5210000000000",
        whatsapp: "",
        email: "correo@ejemplo.com",
        website: "",
        links: [],
        address: "",
        color: "#2E6BFF",
      };
    case "reviews":
      return {
        ...base,
        title: "LO QUE DICEN NUESTROS CLIENTES",
        items: [
          { id: uid(), name: "Ana López", rating: 5, text: "¡Excelente servicio y atención! Sin duda regresaré." },
          { id: uid(), name: "Carlos Ruiz", rating: 5, text: "La mejor calidad de la zona. 100% recomendado." },
        ],
        allowPublic: true,
      };
    case "menu":
      return {
        ...base,
        title: "MENÚ / LISTA DE PRECIOS",
        currency: "$",
        items: [
          { id: uid(), name: "Producto 1", description: "Descripción breve", price: "120", image: "" },
          { id: uid(), name: "Producto 2", description: "Descripción breve", price: "95", image: "" },
        ],
        showOrder: true,
        orderLabel: "Pedir por WhatsApp",
        orderPhone: "5210000000000",
        orderMessage: "Hola, quiero hacer un pedido.",
      };
    case "countdown":
      return {
        ...base,
        title: "¡OFERTA ESPECIAL!",
        subtitle: "Aprovecha antes de que termine",
        targetDate: new Date(Date.now() + 3 * 86400000).toISOString().slice(0, 16),
        color: "#EF4444",
        btnLabel: "Aprovechar ahora",
        btnVariant: "whatsapp",
        btnValue: "5210000000000",
        btnMessage: "Hola, quiero aprovechar la oferta.",
      };
    case "timeline":
      return {
        ...base,
        title: "NUESTRA TRAYECTORIA",
        color: "#2E6BFF",
        items: [
          { id: uid(), year: "2020", title: "Comenzamos", text: "Abrimos nuestras puertas con mucha ilusión." },
          { id: uid(), year: "2023", title: "Crecimiento", text: "Ampliamos servicios y equipo." },
          { id: uid(), year: "2025", title: "Hoy", text: "Miles de clientes satisfechos." },
        ],
      };
    case "audio":
      return {
        ...base,
        title: "Escucha nuestra presentación",
        subtitle: "",
        url: "",
        loop: true,
        background: false,
        hideCard: false,
        color: "#2E6BFF",
      };
    case "stories":
      return {
        ...base,
        title: "HISTORIAS",
        items: [
          { id: uid(), mediaType: "image", thumb: IMG.g1, media: IMG.g1, label: "Novedades", caption: "" },
          { id: uid(), mediaType: "image", thumb: IMG.p1, media: IMG.p1, label: "Productos", caption: "" },
        ],
      };
    case "qr":
      return {
        ...base,
        title: "ESCANEA MI TARJETA",
        url: "",
        fg: "#0A1633",
        bg: "#ffffff",
        caption: "Comparte esta página fácilmente",
      };
    case "image":
      return {
        ...base,
        url: "",
        width: 100,
        ratio: "auto",
        align: "center",
        radius: 16,
        posX: 50,
        posY: 50,
        zoom: 1,
      };
    default:
      return base;
  }
};

export const SOCIAL_PLATFORMS = [  "instagram",
  "facebook",
  "tiktok",
  "whatsapp",
  "youtube",
  "linkedin",
  "x",
  "website",
];

// 15 typography options (loaded via Google Fonts in index.css)
export const TEXT_FONTS = [
  { label: "Poppins", value: "'Poppins', sans-serif" },
  { label: "Inter", value: "'Inter', sans-serif" },
  { label: "Montserrat", value: "'Montserrat', sans-serif" },
  { label: "Playfair Display", value: "'Playfair Display', serif" },
  { label: "Lobster", value: "'Lobster', cursive" },
  { label: "Pacifico", value: "'Pacifico', cursive" },
  { label: "Oswald", value: "'Oswald', sans-serif" },
  { label: "Raleway", value: "'Raleway', sans-serif" },
  { label: "Merriweather", value: "'Merriweather', serif" },
  { label: "Dancing Script", value: "'Dancing Script', cursive" },
  { label: "Bebas Neue", value: "'Bebas Neue', sans-serif" },
  { label: "Roboto Slab", value: "'Roboto Slab', serif" },
  { label: "Caveat", value: "'Caveat', cursive" },
  { label: "Righteous", value: "'Righteous', cursive" },
  { label: "Abril Fatface", value: "'Abril Fatface', serif" },
];

export const TEXT_ANIMS = [
  { label: "Ninguna", value: "none" },
  { label: "Aparecer", value: "fade" },
  { label: "Deslizar", value: "slide" },
  { label: "Pulso", value: "pulse" },
  { label: "Rebote", value: "bounce" },
  { label: "Flotar", value: "float" },
  { label: "Brillo", value: "shine" },
];

export const DIVIDER_STYLES = [
  { key: "gradient", label: "Gradiente" },
  { key: "shimmer", label: "Brillo" },
  { key: "dots", label: "Puntos" },
  { key: "pulse", label: "Pulso" },
  { key: "glow", label: "Punto brillante" },
  { key: "dashed", label: "Guiones" },
  { key: "zigzag", label: "Zigzag" },
  { key: "star", label: "Estrella" },
  { key: "diamond", label: "Diamante" },
  { key: "arrow", label: "Flecha" },
  { key: "wave", label: "Onda" },
  { key: "double", label: "Doble línea" },
];

export const BUTTON_ANIMS = [
  { label: "Ninguna", value: "none" },
  { label: "Pulso", value: "pulse" },
  { label: "Rebote", value: "bounce" },
  { label: "Flotar", value: "float" },
  { label: "Resplandor", value: "glow" },
  { label: "Destello", value: "shine" },
];

// 15 diseños de botón (con movimiento). key => clase .bsh-<key>
export const BUTTON_SHAPES = [
  { key: "rounded", label: "Redondeado" },
  { key: "pill", label: "Píldora" },
  { key: "sharp", label: "Recto" },
  { key: "chamfer", label: "Esquinas cortadas" },
  { key: "hex", label: "Hexágono" },
  { key: "outline", label: "Contorno" },
  { key: "neon", label: "Neón" },
  { key: "shadow3d", label: "Sombra 3D" },
  { key: "dashed", label: "Punteado" },
  { key: "double", label: "Doble línea" },
  { key: "accent", label: "Acento lateral" },
  { key: "underline", label: "Subrayado" },
  { key: "pop", label: "Pulso (zoom)" },
  { key: "blink", label: "Parpadeo" },
  { key: "wobble", label: "Bamboleo" },
];


export const AVATAR_FRAMES = [
  { key: "none", label: "Sin marco" },
  { key: "manual", label: "Color fijo" },
  { key: "rainbow", label: "Arcoíris" },
  { key: "aurora", label: "Aurora" },
  { key: "sunset", label: "Atardecer" },
  { key: "neon", label: "Neón" },
  { key: "gold", label: "Oro" },
  { key: "ocean", label: "Océano" },
  { key: "fire", label: "Fuego" },
  { key: "galaxy", label: "Galaxia" },
];
